<div class="modal-dialog modal-lg" role="document">
  <div class="modal-content">
    <div class="modal-header">
      <div class="d-flex align-items-center gap-3 flex-fill">
        <h6 class="modal-title" i18n>Automation Logs</h6>
        <div class="flex-fill"></div>
        <button (click)="logs?.onRefresh()" class="btn btn-secondary-primary" type="button">
          <i class="far fa-sync"></i> <ng-container i18n>Refresh</ng-container>
        </button>
      </div>
      <a (click)="close()" class="cstm-close">
        <span class="far fa-times"></span>
      </a>
    </div>
    <div class="modal-body">
      <div class="container-box">
        <app-automation-logs #logs [automationGroup]="automationGroup"></app-automation-logs>
      </div>
    </div>
  </div>
</div>
